<template>
  <div class="h-sell-list">

    <div class="sell-list-header h-outer-border around-4 bw2 bz0 h-bg brown-2">
      <div class="artifact">物品</div>
      <div class="gold">售价</div>
      <div class="amount">数量</div>
      <div class="end-time">结束时间</div>
      <div class="owner">卖家</div>
      <div class="misc"></div>
    </div>
    <div class="sell-list">
      <div class="empty" v-if="!sellList.length">暂无寄卖物品</div>
      <div class="sell-item h-outer-border around-4 bw2 bz0 h-bg brown-2"
           :class="{ owner: userId === item.uid }"
           v-for="item in sellList">
        <HArtifact :size="40" :artifact="getArtifactInfo(item)"></HArtifact>
        <div class="table-td">
          {{ item.gold }}
        </div>
        <div class="table-td">
          {{ item.amount }}
        </div>
        <div class="table-td">
          {{ item.endDate | dateFormat }}
        </div>
        <div class="table-td nick">
          {{ item.nick }}
        </div>
        <div class="table-td misc">
          <button class="h-btn normal"
                  v-click-sound-button
                  :disabled="userId === item.uid"
                  @click="handleBuy(item)">购买
          </button>
        </div>
      </div>
    </div>

    <HPager :page="pager.page" :pageSize="pager.pageSize" :total="pager.total" @pageChange="handlePageChange"></HPager>

    <BuyPopup v-if="buyPopupShow"
              :itemInfo="buyItemInfo"
              @close="buyPopupShow=false"
              @refresh="handleRefresh">
    </BuyPopup>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import HArtifact from '@/components/h-artifact/index'
  import HPager from '@/components/base/h-pager/index'
  import BuyPopup from './buy-popup'
  import API from '@js/api'
  import DateFormat from '@js/date-format'

  export default {
    name: 'sell-list',

    filters: {
      dateFormat (v) {
        return DateFormat(v, 'YYYY-MM-DD hh:mm')
      }
    },

    data () {
      return {
        sellList: [],
        buyItemInfo: null,
        buyPopupShow: false,
        pager: {
          page: 0,
          pageSize: 5,
          total: 0,
        },
      }
    },

    computed: {
      ...mapGetters('user', [
        'userId',
      ]),

      ...mapGetters('hero', [
        'gold',
      ]),
    },

    mounted () {
      this.getSellList()
    },

    methods: {
      ...mapActions('hero', [
        'getGold',
      ]),

      getArtifactInfo (item) {
        const data = { ...item }
        delete data.endDate
        return data
      },

      async getSellList () {
        try {
          const { list, count } = await API.market.getSellList({
            page: this.pager.page,
            pageSize: this.pager.pageSize,
          })
          this.sellList = list
          this.pager.total = count
        } catch (err) {
          console.error(err)
        }
      },

      handleBuy (item) {
        this.buyItemInfo = JSON.parse(JSON.stringify(item))
        this.buyPopupShow = true
      },

      handleRefresh () {
        this.getGold()
        this.getSellList()
      },

      handlePageChange (page) {
        this.pager.page = page
        this.getSellList()
      },
    },

    components: {
      HArtifact,
      BuyPopup,
      HPager,
    },
  }
</script>

<style lang="stylus" scoped>
  .sell-list-header
    margin-bottom 2px
    display flex
    padding 5px 2px
    line-height 16px
    font-size 12px
    letter-spacing 1px
    text-align center
    goldText1()
    > div
      width 135px
    .artifact
      width 40px

  .empty
    padding-top 10px
    line-height 20px
    text-align center
    font-size 12px
    letter-spacing 1px
    whiteText1()

  .sell-list
    height 245px

  .sell-item
    display flex
    padding 2px
    &:not(:last-child)
      margin-bottom 5px
    > div
      flex-shrink 0
    .table-td
      display flex
      justify-content center
      align-items center
      width 135px
      font-size 12px
      letter-spacing 1px
      whiteText1()
    .misc
      justify-content flex-end
      .h-btn
        width 51px
        height 24px
        line-height 24px
        font-size 12px
    &.owner .nick
      color $colorLightBlue

</style>
